import { Fragment } from 'react'
import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components'

import { Chip } from '../chip'

interface CategoryProps {
  categoryList: { id: number; name: string; description: string; sortIndex: number }[]
  categoryId: number | undefined
  setCategoryId: (id: number | undefined) => void
}

export function Category({ categoryList, categoryId, setCategoryId }: CategoryProps) {
  return (
    <StyledSwiper autoHeight={true} freeMode={true} slidesPerView="auto" spaceBetween={8} modules={[FreeMode]}>
      {categoryList.map(({ id, name }, index) => {
        if (typeof id === 'undefined') return <Fragment key={`f${index}`} />
        const isActive = (id === 1 && categoryId === undefined) || categoryId === id
        return (
          <SlideItem key={index}>
            <Chip $color={isActive ? 'black' : 'white'} onClick={() => setCategoryId(id === 1 ? undefined : id)}>
              {name === '미지정' ? '전체' : (name ?? '-')}
            </Chip>
          </SlideItem>
        )
      })}
    </StyledSwiper>
  )
}

const StyledSwiper = styled(Swiper)`
  margin: 0;
  padding: 0 16px;
`

const SlideItem = styled(SwiperSlide)`
  width: auto !important;
  height: 35px !important;
  line-height: 100%;
`
